import { NavLink, Outlet } from 'react-router';
import { Brand } from '../brand/Logo';
import { LANG_NAMES, LANGS, setLang, useLang, useT } from '../i18n';
import './Layout.css';

/** Each language named in itself; the short form is for phones. */
const LANG_BUTTONS = {
  en: { long: 'EN', short: 'EN' },
  fr: { long: 'FR', short: 'FR' },
  ko: { long: '한국어', short: '한' },
} as const;

export function Layout() {
  const t = useT();
  const lang = useLang();
  return (
    <div className="layout-shell">
      <a className={`layout-skip btn btn-small`} href="#main">
        {t.nav.skip}
      </a>
      <header className="layout-header">
        <NavLink to="/" className="layout-home" aria-label={t.nav.home}>
          <Brand size={26} />
        </NavLink>
        <div className="layout-right">
          <nav aria-label={t.nav.main} className="layout-nav">
            <NavLink to="/play/bot">{t.nav.play}</NavLink>
            <NavLink to="/play/online">{t.nav.online}</NavLink>
            <NavLink to="/learn">{t.nav.learn}</NavLink>
          </nav>
          <div className="segmented layout-lang" role="group" aria-label={t.nav.language}>
            {LANGS.map((l) => (
              <button
                key={l}
                type="button"
                lang={l}
                aria-pressed={lang === l}
                aria-label={LANG_NAMES[l]}
                onClick={() => setLang(l)}
              >
                <span className="layout-langLong">{LANG_BUTTONS[l].long}</span>
                <span className="layout-langShort" aria-hidden="true">
                  {LANG_BUTTONS[l].short}
                </span>
              </button>
            ))}
          </div>
        </div>
      </header>
      <main id="main" className="layout-main">
        <Outlet />
      </main>
    </div>
  );
}
